import EmptyStateAction from '@/common/components/EmptyStateAction/EmptyStateAction';

export default EmptyStateAction;
